module.exports = __webpack_public_path__ + "static/media/transmisores-01.dfbcdaa8.jpg";